<script>
import _ from 'lodash'

import { addContentToSection, sortContents } from '@/helpers'
import { useSetupStore } from '@/stores'

import InputContents from '@/components/Page/Sections/Partials/InputContents'
import InputContent from './InputContent'

export default {
    name: 'InputContents',
    extends: InputContents,
    components: {
        InputContent,
    },
    computed: {
        contents: {
            get() {
                let contents = _.get(this.section, 'contents') || []
                // return _.filter(contents, { key: this.config.key })
                return contents.filter(content => {
                    if (content.key === 'additional-field' && content.settings && content.settings.length) {
                        const type = content.settings.find(el => el.key === 'type')
                        if (type && type.value === 'newsletter-checkbox' && !this.enabledExtensions.includes('newsletter')) {
                            return false
                        }
                    }

                    return content.key === this.config.key
                        // && this.checkConditions(content)
                        && ! (['email-intro', 'user-name', 'user-email'].includes(this.config.key) && content.deleted)
                })
            },
            set(sorted) {
                // sort
                let contents = _.get(this.section, 'contents') || []
                contents.forEach(content => {
                    const i = sorted.findIndex(el => el.id === content.id)
                    content.position = i + 1
                });
                sortContents(contents)
            }
        },
        allowedToAddContent() {
            return _.get(this.config, 'max', 1) > this.contents.length
                && ! ['email-intro', 'user-name', 'user-email'].includes(this.config.key)
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions
        }
    },
}
</script>

<style lang="sass" scoped></style>
